import axios from 'axios';

export const sendTicket = async (params: ISendTicketParams): Promise<void> => {
  const ticket = {
    category: params.category,
    subcategory: params.subcategory,
    message: params.message,
    requester: {
      name: params.name,
      email: params.email,
      phone: params.phone,
      typology: params.typology,
    },
  };

  try {
    if (params.attachment) {
      const formData = new FormData();
      formData.append('ticket', JSON.stringify(ticket));
      formData.append('attachment', params.attachment, params.attachment.name);
      await axios.post(getTicketsUrl(), formData);
      return;
    }

    await axios.post(getTicketsUrl(), { ticket });
  } catch (err: unknown) {
    let error = 'Something went wrong.';
    if (err instanceof Error) {
      error += ` ${err.message}`;
    }

    throw new Error(error);
  }
};

const getTicketsUrl = (): string =>
  `${process.env.GATSBY_GATEWAY_API}/v1/tickets`;

export interface ISendTicketParams {
  category: string;
  subcategory: string;
  message: string;
  name: string;
  email: string;
  phone: string;
  typology: string;
  desired_typology?: string;
  attachment?: File;
}

export interface IZendeskCustomField {
  id: number;
  value: string | string[];
}
